import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { Link } from "../../common/link/Link"

import * as s from "./Cta.module.scss"
import { setState } from "../../../ducks/sidebarSlice"
import { Props } from "./Cta.interface"

export const Cta = ({
  ariaLabel,
  className,
  title,
  link,
  onClick,
  target,
  external,
  disabled,
  download,
}: Props) => {
  const [sidebarOverride, setSidebarOverride] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    setSidebarOverride(
      !download && link?.includes("newsletter") ? "NEWSLETTER" : null,
    )
  }, [link, download])

  return (
    <div
      className={`${s.Cta} ${className || ""} ${disabled ? s.disabled : ""}`}
      onClick={() => {
        if (onClick) {
          onClick()
        }
        if (!download && sidebarOverride) {
          dispatch(
            setState({
              sidebarIsVisible: true,
              content: sidebarOverride,
            }),
          )
        }
      }}
    >
      <div className={s.Cta__inner}>
        {link && download && (
          <a
            className={s.Cta__link}
            href={link}
            download={download}
            aria-label={ariaLabel}
          >
            <span className={`${s.Cta__link__title} ${s.cta__download}`}>
              {title}
            </span>
          </a>
        )}

        {link && !download && external && (
          <a className={s.Cta__link} href={link} target={target || "_blank"}>
            <span className={s.Cta__link__title}>{title}</span>
          </a>
        )}

        {link && !download && !external && !sidebarOverride && (
          <Link
            className={s.Cta__link}
            to={`${link}`}
            target={target && target}
            aria-label={ariaLabel}
          >
            <span className={s.Cta__link__title}>{title}</span>
          </Link>
        )}

        {!link && (
          <button className={s.Cta__link} role="button">
            <span className={s.Cta__link__title}>{title}</span>
          </button>
        )}

        {!download && sidebarOverride && (
          <div className={s.Cta__link}>
            <span className={s.Cta__link__title}>{title}</span>
          </div>
        )}
      </div>
    </div>
  )
}
